<template>
  <div class="ques_law_win">
    <div>
      <img src="~assets/home/lvshi_lv_sample1.png" />
    </div>
    <div class="ol_law_info" :class="{bor_bottom:isBorder}">
      <div class="simple_des">
        <div class="name">XX律师 <span>专职律师</span></div>
        <div class="des ellipsis">专业律师团队</div>
      </div>
      <div class="detail_des text_center">
        <div class="name">XX律师</div>
        <div class="good_at">刑事辩护、交通事故</div>
        <div class="phone center">
          <svg-icon icon-class="dianhua" class="svgimg"/> 1776588112
        </div>
        <div class="consult center text_hover_shou" v-if="ConsultOrMore">
          在线咨询
        </div>
        <div class="more" v-if="!ConsultOrMore">了解详情 >></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ConsultOrMore: {
      type: Boolean,
      default: false,
    },
    isBorder:{
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scope>
.ques_law_win {
  position: relative;
  &:hover {
    .ol_law_info {
      transition: height .3s;
      height: 128px;
      .simple_des {
        display: none;
      }
    }
    .bor_bottom{
      border-bottom: 3px #0465EA solid;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
  }
  .ol_law_info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 91px;
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    overflow: hidden;

    .simple_des {
      width: 100%;
      padding: 18px 10px;
      .name {
        font-size: 18px;
        color: #333;
        > span {
          font-size: 16px;
          color: #0465ea;
          margin-left: 3px;
        }
      }
      .des {
        margin-top: 8px;
        font-size: 14px;
        color: #666;
      }
    }

    .detail_des {
      color: #666666;
      width: 100%;
      padding: 12px 0 17px;
      height: 0;
      .name {
        font-size: 20px;
        color: #333333;
      }
      .good_at {
        margin-top: 5px;
        font-size: 14px;
      }
      .phone {
        margin: 8px 0;
        font-size: 14px;
        .svgimg {
          font-size: 16px;
          color: #1375FF;
        }
      }
      .more {
        font-size: 12px;
        cursor: pointer;
      }
      .consult {
        width: 82px;
        height: 23px;
        margin: 0 auto;
        font-size: 14px;
        background: #f25618;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>